import { FC } from 'react'
import SeverityIndicatorCritical from '@/assets/images/severity-indicator-critical.svg?react'
import SeverityIndicatorWarning from '@/assets/images/severity-indicator-warning.svg?react'
import SeverityIndicatorModerate from '@/assets/images/severity-indicator-moderate.svg?react'
import SeverityIndicatorLow from '@/assets/images/severity-indicator-low.svg?react'
import SeverityIndicatorInformational from '@/assets/images/severity-indicator-informational.svg?react'
import SeverityIndicatorClean from '@/assets/images/severity-indicator-clean.svg?react'
import { IconTypesProps } from './iconTypes'

type SeverityIndicatorIconProps = IconTypesProps & {
    severity:
        | 'critical'
        | 'important'
        | 'high'
        | 'moderate'
        | 'medium'
        | 'low'
        | 'informational'
        | 'clean'
}

export const SeverityIndicatorIcon: FC<SeverityIndicatorIconProps> = ({
    severity,
    dataTestId,
    width = '14',
    height = '14',
}) => {
    const props = {
        width,
        height,
        severity,
    }

    switch (severity) {
        case 'critical':
            return (
                <SeverityIndicatorCritical
                    data-testid={dataTestId}
                    {...props}
                />
            )
        case 'important':
        case 'high':
            return (
                <SeverityIndicatorWarning data-testid={dataTestId} {...props} />
            )
        case 'moderate':
        case 'medium':
            return (
                <SeverityIndicatorModerate
                    data-testid={dataTestId}
                    {...props}
                />
            )
        case 'low':
            return <SeverityIndicatorLow data-testid={dataTestId} {...props} />
        case 'informational':
            return (
                <SeverityIndicatorInformational
                    data-testid={dataTestId}
                    {...props}
                />
            )
        case 'clean':
            return (
                <SeverityIndicatorClean data-testid={dataTestId} {...props} />
            )
        default:
            return null
    }
}

export default SeverityIndicatorIcon
